import PropTypes from 'prop-types'
import React from 'react'
import Header from 'components/Header'
import { ROUTES } from 'constants/routes'

const FaqLayoutHeader = ({ showSidebarToggle = false }) => (
  <Header
    alwaysShowActions
    faqPath={ROUTES.CABINET_FAQ}
    hasBalance={false}
    openFaqInNewTab={false}
    showSidebarToggle={showSidebarToggle}
  />
)

FaqLayoutHeader.propTypes = {
  showSidebarToggle: PropTypes.bool,
}

export default FaqLayoutHeader
